// Taiwan market currency symbol converter
(function() {
  'use strict';
  
  // Check if we're in Taiwan market (you can adjust this condition based on your setup)
  function isTaiwanMarket() {
    // Check multiple indicators for Taiwan market
    const isLocaleTW = document.documentElement.lang === 'zh-TW' || 
                      document.documentElement.lang === 'zh-Hant-TW';
    const isCurrencyTWD = window.Shopify && window.Shopify.currency && 
                         window.Shopify.currency.active === 'TWD';
    const isCountryTW = window.Shopify && window.Shopify.country === 'TW';
    
    // You can also check URL path or domain
    const urlHasTaiwan = window.location.pathname.includes('/tw/') || 
                         window.location.hostname.includes('.tw');
    
    return isLocaleTW || isCurrencyTWD || isCountryTW || urlHasTaiwan;
  }
  
  // Early exit if not Taiwan market - don't set up any listeners or modifications
  if (!isTaiwanMarket()) {
    return;
  }
  
  // Convert $ to NTD in price elements
  function convertCurrencySymbol(forceReset = false) {
    if (!isTaiwanMarket()) {
      return;
    }
    
    // Reset all converted markers if force reset is true (for AJAX updates)
    if (forceReset) {
      document.querySelectorAll('[data-currency-converted]').forEach(element => {
        element.removeAttribute('data-currency-converted');
      });
    }
    
    // Define selectors for price elements (adjust based on your theme)
    const priceSelectors = [
      '.product-grid-item__price',
      '.product-grid-item__price-new',
      '.product__price',
      '.product__price-new',
      '.cart__price',
      '.cart-item__price',
      '.cart__item__price',
      '.cart__total__money',
      '[data-cart-total-price]',
      '[data-cart-price-holder]',
      '[data-api-cart-price]',
      '.price',
      '.money',
      '[data-price]',
      '[data-price-wrapper]',
      'span:contains("$")',
      's:contains("$")'
    ];
    
    // Process each selector
    priceSelectors.forEach(selector => {
      try {
        let elements;
        
        // Handle jQuery-style :contains selector
        if (selector.includes(':contains')) {
          const searchText = '$';
          elements = Array.from(document.querySelectorAll(selector.split(':')[0]))
            .filter(el => el.textContent.includes(searchText));
        } else {
          elements = document.querySelectorAll(selector);
        }
        
        elements.forEach(element => {
          // Skip if already converted
          if (element.getAttribute('data-currency-converted') === 'true') {
            return;
          }
          
          // Get all text nodes in the element
          const walker = document.createTreeWalker(
            element,
            NodeFilter.SHOW_TEXT,
            null,
            false
          );
          
          let node;
          while (node = walker.nextNode()) {
            const text = node.textContent;
            // Match currency patterns: $XXX, $ XXX, $X,XXX.XX etc.
            if (/\$[\s]*[\d,]+/.test(text)) {
              // Replace $ with NTD but preserve formatting
              node.textContent = text.replace(/\$/g, 'NTD ');
            }
          }
          
          // Mark as converted to avoid duplicate processing
          element.setAttribute('data-currency-converted', 'true');
        });
      } catch (e) {
        console.warn('Currency converter: Error processing selector', selector, e);
      }
    });
  }
  
  // Run on page load
  document.addEventListener('DOMContentLoaded', convertCurrencySymbol);
  
  // Run after AJAX updates (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    // Check if any mutation is related to price elements
    let shouldConvert = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        // Check if the mutation target or its parent contains price-related content
        const target = mutation.target;
        const targetElement = target.nodeType === Node.TEXT_NODE ? target.parentElement : target;
        if (targetElement) {
          const text = targetElement.textContent || '';
          if (text.includes('$') && /\$[\s]*[\d,]+/.test(text)) {
            shouldConvert = true;
          }
        }
      }
    });
    
    if (shouldConvert) {
      // Immediate conversion for price changes
      convertCurrencySymbol(true);
      // Additional delayed checks to catch any subsequent updates
      setTimeout(() => convertCurrencySymbol(false), 200);
      setTimeout(() => convertCurrencySymbol(false), 400);
    }
  });
  
  // Start observing when DOM is ready
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }
  
  // Also handle Shopify AJAX cart events
  document.addEventListener('cart:refresh', () => convertCurrencySymbol(true));
  document.addEventListener('product:loaded', () => convertCurrencySymbol(true));
  document.addEventListener('variant:changed', () => convertCurrencySymbol(true));
  
  // Handle various cart update events
  document.addEventListener('theme:cart:update', () => convertCurrencySymbol(true));
  document.addEventListener('ajaxCart:updated', () => convertCurrencySymbol(true));
  document.addEventListener('cart:updated', () => convertCurrencySymbol(true));
  
  // Only intercept AJAX if we're in Taiwan market
  if (isTaiwanMarket()) {
    // Watch for specific AJAX cart responses
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then(response => {
        // Re-check if still in Taiwan market
        if (isTaiwanMarket()) {
          const url = args[0];
          if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
            // Multiple delayed checks to catch all updates
            setTimeout(() => convertCurrencySymbol(true), 100);
            setTimeout(() => convertCurrencySymbol(true), 300);
            setTimeout(() => convertCurrencySymbol(true), 500);
          }
        }
        return response;
      });
    };
    
    // Also intercept XMLHttpRequest for older AJAX implementations
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(_, url) {
      this.addEventListener('load', function() {
        // Re-check if still in Taiwan market
        if (isTaiwanMarket() && url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
          // Multiple delayed checks to catch all updates
          setTimeout(() => convertCurrencySymbol(true), 100);
          setTimeout(() => convertCurrencySymbol(true), 300);
          setTimeout(() => convertCurrencySymbol(true), 500);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }
  
  // Expose function globally for manual trigger if needed
  window.convertToTaiwanCurrency = convertCurrencySymbol;
})();